import script from "./ForUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ForUsers.vue?vue&type=script&setup=true&lang=js"

import "./ForUsers.vue?vue&type=style&index=0&id=1821ad8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1821ad8e"]])

export default __exports__